import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { ToggleExample, CheckAndToggleExample, RadioExample, SelectExample, SelectAndRadioExample, InputExample, RangeExample, TimerExample, RowsOfSlidersExample, SlidersOnTwoRowsExample } from '../../components/examples/controls-examples';
import { TimerAPI } from '../../components/api';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "timer"
    }}>{`Timer`}</h1>
    <p>{`You can also explicitly specify your timer, so it can be anywhere you want in the controls, not just at the very end (default).`}</p>
    <TimerExample mdxType="TimerExample" />
The Timer takes the following props:
    <TimerAPI mdxType="TimerAPI" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Model
  showTimer={false}
  controls={{
    type: 'timer',
    label: 'My explicit timer',
  }}
/>
`}</code></pre>
    <p>{`If you explictly include a `}<inlineCode parentName="p">{`timer`}</inlineCode>{` through the `}<inlineCode parentName="p">{`controls`}</inlineCode>{` prop of `}<inlineCode parentName="p">{`Model`}</inlineCode>{`, then the `}<a parentName="p" {...{
        "href": "/react-sim/controls/default-timer"
      }}>{`default timer`}</a>{` won't be added at the end.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      